<template>
  <b-modal
      id="order-print-az-sf-modal"
      ref="order-print-az-sf-modal"
      hide-footer
      hide-header
      size="lg"
      @hidden="handHiden"
      @shown="handShown"
  >
    <b-button class="pull-right" variant="success" @click="print">Yazdır</b-button>
     <div id="printArea">
      <div class="book" v-if="seletedOrders.includes(order.id)" v-for="(order,index) in _orders" :key="order.id">
        <div class="page">
          <div class="subpage4">
            <div class="az-sf-image-container">
              <img :src="'data:image/jpeg;base64, '+label(order.id).png_code"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-button class="pull-right" variant="success" @click="print">Yazdır</b-button>
  </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import ViewDate from "@/views/common/ViewDate";
import VueBarcode from 'vue-barcode';

export default {
  name: "OrderPrintAzSf",
  components: {ViewDate, VueBarcode},
  data: () => ({
    userData: JSON.parse(localStorage.getItem('userData')),
  }),
  computed: {
    ...mapGetters("order", ["_selectedOrder", "_selectedOrders", "_orders"]),
    ...mapGetters('orderCommonLabel', ["_labels"]),
    seletedOrders() {
      if (this._selectedOrder) {
        return [this._selectedOrder];
      }
      return this._selectedOrders;
    }
  },
  methods: {
    label(order_id) {
      let item = this._labels.find(item => item.order_id == order_id)
      if (!item) return {}
      return item
    },
    handHiden() {
      this.$store.commit('order/setSelectedOrder', "");
    },
    async handShown() {
      await this.print();
    },
    async print() {
      await this.$htmlToPaper('printArea', {
        styles: [`${process.env.BASE_URL}order-print-az-sf.css`],
      });
    }
  }
}
</script>
